import GuessHomeRooms from "../../components/Nursery/GeneralAwareness/GuessHomeRooms";
import MatchHomeItems from "../../components/Nursery/GeneralAwareness/MatchHomeItems";


// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}

document.title = "Mamas Guidance - Nursery - General Awareness - My Home"; // Set page title

const topics: MenuItem[] = [
    { url: "/nursery/general-awareness/my-home/guess-home-rooms", title: "Guess Room", component: GuessHomeRooms},
    { url: "/nursery/general-awareness/my-home/match-home-items", title: "Match Home Items", component: MatchHomeItems},
];


export default topics;